// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".style__app___ZFt4_{display:flex;flex-direction:row;height:100vh;min-width:1024px;overflow-y:hidden}.style__app__right___amk3d{display:flex;flex-direction:column;flex:1;overflow-x:hidden}.style__app__content____833K{overflow:auto;position:relative;flex:1}@media only screen and (max-width: 767px){.style__app__content____833K{min-width:380px;overflow-x:hidden}}.style__app__topbar___wdEnj{flex-grow:0;flex-shrink:0}", "",{"version":3,"sources":["webpack://./src/features/App/style.scss"],"names":[],"mappings":"AAEA,oBACE,YAAA,CACA,kBAAA,CACA,YAAA,CACA,gBAAA,CACA,iBAAA,CAGF,2BACE,YAAA,CACA,qBAAA,CACA,MAAA,CACA,iBAAA,CAGF,6BACE,aAAA,CACA,iBAAA,CACA,MAAA,CAAA,0CAHF,6BAMI,eAAA,CACA,iBAAA,CAAA,CAIJ,4BACE,WAAA,CACA,aAAA","sourcesContent":["@import \"../../styles/defaultMixins\";\n\n.app {\n  display: flex;\n  flex-direction: row;\n  height: 100vh;\n  min-width: 1024px;\n  overflow-y: hidden;\n}\n\n.app__right {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  overflow-x: hidden;\n}\n\n.app__content {\n  overflow: auto;\n  position: relative;\n  flex: 1;\n\n  @include small {\n    min-width: 380px;\n    overflow-x: hidden;\n  }\n}\n\n.app__topbar {\n  flex-grow: 0;\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"default-turquoise": "#0d91bd",
	"error-red": "#f9453e",
	"border-grey": "#e9e9e9",
	"white": "#fff",
	"default-blue": "#557eff",
	"active-blue": "#3750cd",
	"glowing-blue": "#0d47ff",
	"text-black": "#555",
	"text-grey": "#778195",
	"disabled-grey-background": "#f9fafb",
	"disabled-grey-text": "#a8a8a8",
	"disabled-light-grey-text": "#c2c2c2",
	"disabled-grey-button": "#969696",
	"disabled-light-grey-button": "#c2c2c2",
	"disabled-grey-button-hover": "#545454",
	"success-green": "#03b571",
	"list-item-grey": "#f3f3f3",
	"outline-color": "#79c2db",
	"greyout": "#fafafa",
	"button-hover": "#7395ff",
	"button-active": "#3750cd",
	"light-orange": "#eba205",
	"input-focus-shadow": "rgba(13,145,189,.2509803922)",
	"floatingSideBarResolutionBreakpoint": "1280px",
	"app": "style__app___ZFt4_",
	"app__right": "style__app__right___amk3d",
	"app__content": "style__app__content____833K",
	"app__topbar": "style__app__topbar___wdEnj"
};
export default ___CSS_LOADER_EXPORT___;
